module.exports = __webpack_public_path__ + "static/media/afternoon.e0443f36.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifs/afternoon.gif
// module id = 846
// module chunks = 0